module.exports = __webpack_public_path__ + "static/media/img_overpaper2@2x.29b9b578.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_overpaper2@2x.png
// module id = 961
// module chunks = 0